import { __read } from 'tslib';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { EditorLinkDialog } from '../EditorLinkDialog/EditorLinkDialog.js';
import '../EditorContext/EditorContext.js';
import { EditorSelectionMenu } from '../EditorSelectionMenu/EditorSelectionMenu.js';
import { EditorToolbar } from '../EditorToolbar/EditorToolbar.js';

var EditorControls = function () {
    var _a = __read(useState(false), 2), showLinkDialog = _a[0], setShowLinkDialog = _a[1];
    return (jsxs(Fragment, { children: [jsx(EditorSelectionMenu, { setShowLinkDialog: setShowLinkDialog, showLinkDialog: showLinkDialog }), jsx(EditorToolbar, { setShowLinkDialog: setShowLinkDialog, showLinkDialog: showLinkDialog }), showLinkDialog && (jsx(EditorLinkDialog, { isOpen: showLinkDialog, closeDialog: function () { return setShowLinkDialog(false); } }))] }));
};

export { EditorControls };
//# sourceMappingURL=EditorControls.js.map
